import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { message } from "antd";
import { isMobile } from "react-device-detect";
import Layout from "../components/Layout/Layout";
import IMAGES from "../img/image.js";
import website from "../website/data.js";
import HeroSvg from "../components/Layout/HeroSvg";
import {
	ChevronLeftSvg,
	ListSvg,
} from "../components/AllSvgModulesExport/LoginSvg";
import {
	setActiveButton,
	setShowAccountModal,
} from "../redux/features/footerMenuSlice.js";
import SideMenu from "../components/Header/SideMenu";
// ICONS
import TollIcon from "@mui/icons-material/Toll";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import VerifiedIcon from "@mui/icons-material/Verified";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import ClearIcon from "@mui/icons-material/Clear";
import TelegramIcon from "@mui/icons-material/Telegram";
// CSS
import "./css/ProductInfo.css";
import "./css/ProductInfoMobile.css";
import { UserIdSvg, ZoneIdSvg } from "../components/Header/AccountModalSvg";
import Loader from "./Loader";
import AccountModal from "../components/Header/AccountModal";
import { apiClient } from "../config/api.client.js";
import { getUser } from "../services/user.service";
import MarketingConsentCheckbox from "../components/MarketingConsent/MarketingConsentCheckbox";

const ProductInfo = () => {
	const params = useParams();
	const location = useLocation();
	const passedGame = location?.state?.game;
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { user } = useSelector((state) => state.user);
	const { showAccountModal, showSearchModal } = useSelector((state) => state.footerMenu);
	const [sideMenu, setSideMenu] = useState(false);
	const [loading, setLoading] = useState(false);
	const [playerCheck, setPlayerCheck] = useState(null);
	const [product, setProduct] = useState(0);
	const [showImage, setShowImage] = useState(0);
	const [error, setError] = useState(false);
	const [mode, setMode] = useState("WALLET");
	const [payment, setPayment] = useState("WALLET");
	const [paymentOptions, setPaymentOptions] = useState("");
	//!NEW STATE
	const [amount, setAmount] = useState(null);
	const [selectedPrice, setSelectedPrice] = useState(null);
	const [productId, setProductId] = useState("");
	const [prodId, setProdId] = useState("");
	//! API BASED
	const [orderId, setOrderId] = useState(false);
	const [userId, setUserId] = useState("");
	const [zoneId, setZoneId] = useState("");
	const [balance, setBalance] = useState("");
	const [orderSuccess, setOrderSuccess] = useState(false);
	const [data, setData] = useState(null);
	const [coupon, setCoupon] = useState(null);
	const [couponApplied, setCouponApplied] = useState(null);
	const [discount, setDiscount] = useState("");
	const [finalAmount, setFinalAmount] = useState("");
	const [couponName, setCouponName] = useState("");
	const [originalPrice, setOriginalPrice] = useState(null);
	// payment mode
	const [paymentMode, setPaymentMode] = useState("");
	const [desc, setDesc] = useState("");
	const [img, setImg] = useState("");
	const [utr, setUtr] = useState("");
	const [walletDiscount, setWalletDiscount] = useState("");
	const [mobilePopup, setMobilePopup] = useState(false);
	const [marketingConsent, setMarketingConsent] = useState(false);
	const [alreadyOptedIn, setAlreadyOptedIn] = useState(false);

	// Hide the opt-in checkbox for users who have already opted in
	useEffect(() => {
		if (!user?._id) return;
		getUser()
			.then((data) => setAlreadyOptedIn(data?.marketingConsent === true))
			.catch(() => setAlreadyOptedIn(false));
	}, [user?._id]);

	async function getWalletDiscount() {
		try {
			const res = await apiClient.get("/wallet/getdiscount", {
				headers: {
					Authorization: "Bearer " + localStorage.getItem("token"),
				},
			});
			if (res.data.success) {
				setWalletDiscount(res.data.data);
			}
		} catch (error) {
			console.log(error);
		}
	}
	useEffect(() => {
		getWalletDiscount();
		// if (!user) {
		//   navigate("/login");
		// }
	}, []);



	const getAllCoupons = async () => {
		try {
			const res = await apiClient.get("/admin/get-coupons");
			if (res.data.success) {
				setData(res.data.data);
			}
		} catch (error) {
			console.log(error);
		}
	};

	// Payment mode
	async function getPaymentMode() {
		try {
			const res = await apiClient.get("/paymentmode/get-mode", {
				headers: {
					Authorization: "Bearer " + localStorage.getItem("token"),
				},
			});
			if (res.data.success) {
				setPaymentMode(res.data.data.paymentMode);
				setDesc(res.data.data.desc);
				setImg(res.data.data.image);
			} else {
				message.error(res.data.message);
			}
		} catch (error) {
			console.log(error);
		}
	}

	useEffect(() => {
		getPaymentMode();
	}, []);

	// ==== COUPON
	function applyCoupon(e) {
		e.preventDefault();
		if (data?.length === 0 || data === null) {
			return message.error("No Coupon Found");
		}
		if (coupon === "") {
			setError(true);
			setTimeout(() => {
				setError(false);
			}, 1500);
			return;
		}
		// find coupon
		const couponCode = data && data?.find((item) => item.name === coupon);
		setCouponName(couponCode?.name);

		if (!couponCode) {
			return message.error("No Coupon Found");
		}

		if (couponCode?.minValue >= selectedPrice) {
			message.error(`Minimum order value is: ${couponCode?.minValue}`);
			return;
		}
		//
		if (coupon) {
			setCouponApplied(true);
			setDiscount(couponCode?.discount);
			setFinalAmount(selectedPrice - couponCode?.discount);
			message.success("Coupon applied success");
		} else {
			message.error("No coupon found");
		}
	}
	const removeDiscount = () => {
		setCouponApplied(false);
		setFinalAmount((prev) => prev + discount);
	};
	// ==== COUPON ENDS

	// GETTING PRICE
	function setPriceAndId(amount, prodId) {
		if (user?.reseller === "yes") {
			const price = product?.cost?.find(
				(item) => item.prodId === prodId
			)?.resPrice;
			// game id
			const id = product?.cost?.find((item) => item.amount === amount)?.id;
			// buying price
			const ogPrice = product?.cost?.find(
				(item) => item.amount === amount
			)?.buyingprice;

			setSelectedPrice(price);
			setFinalAmount(price);
			setProductId(id);
			setOriginalPrice(ogPrice);
			if (couponApplied) {
				setCouponApplied(false);
			}
		} else {
			const price = product?.cost?.find(
				(item) => item.prodId === prodId
			)?.price;
			setSelectedPrice(price);
			setFinalAmount(price);
			const id = product?.cost?.find((item) => item.amount === amount)?.id;
			setProductId(id);
			// buying price
			const ogPrice = product?.cost?.find(
				(item) => item.amount === amount
			)?.buyingprice;
			setOriginalPrice(ogPrice);
			if (couponApplied) {
				setCouponApplied(false);
			}
		}
	}

	// GET PRODUCT DETAILS
	const getProduct = async () => {
		try {
			const isIdLike = /^[a-f0-9]{24}$/i.test(params.name);
				if (isIdLike) {
					const res = await apiClient.get(`/games/${params.name}/diamond-packs`);
					if (res.data?.success) {
						const packs = res.data.diamondPacks || [];
						const gameData = res.data.gameData || {};
						const validationFields = Array.isArray(gameData.validationFields)
							? gameData.validationFields
							: [];
						const toLabel = (key) => {
							if (!key) return "";
							return key
								.replace(/([a-z])([A-Z])/g, "$1 $2")
								.replace(/_/g, " ")
								.replace(/^\w/, (c) => c.toUpperCase());
						};
						const tagOneLabel = toLabel(validationFields[0]) || "Player ID";
						const tagTwoLabel = toLabel(validationFields[1]) || "Server";
						const fieldsCount = Math.min(validationFields.length || 1, 2);

						const normalized = {
							name: gameData?.name || passedGame?.name || "",
							image: gameData?.image || passedGame?.image || "",
							desc: gameData?.publisher || passedGame?.publisher || "",
							gameCode: gameData?.productId || "",
							fields: String(fieldsCount),
							tagOne: tagOneLabel,
							tagTwo: tagTwoLabel,
							playerCheckBtn: "yes",
							cost: packs.map((p) => ({
								prodId: p._id,
								amount: p.amount,
								price: p.amount,
								resPrice: p.amount,
								fakePrice: undefined,
								pimg: p.logo,
								packData: p.description,
								status: p.status === "active" ? "yes" : "no",
								id: p._id,
								cashback: p.cashback
							}))
						};
						setProduct(normalized);
					if (normalized.cost?.length) {
						const c0 = normalized.cost[0];
						setAmount(c0.amount);
						setSelectedPrice(c0.price);
						setFinalAmount(c0.price);
						setOriginalPrice(c0.price);
						setProductId(c0.id);
						setProdId(c0.prodId);
					}
					return;
				} else {
					message.error(res.data?.message || "Failed to load packs");
				}
			}

			const res = await apiClient.post("/product/get-product-by-name", {
				name: params.name,
			});
			if (res.data.success) {
				setProduct(res.data.data);
				const defaultAmount = res.data.data?.cost?.[0]?.amount;
				const defaultProdId = res.data.data?.cost?.[0]?.prodId;
				const defaultPrice =
					user?.reseller === "yes"
						? res.data.data?.cost?.[0]?.resPrice
						: res.data.data?.cost?.[0]?.price;
				const defaultId = res.data.data?.cost?.[0]?.id;
				const defaultOriginalPrice = res.data.data?.cost?.[0]?.buyingprice;

				setAmount(defaultAmount);
				setSelectedPrice(defaultPrice);
				setFinalAmount(defaultPrice);
				setOriginalPrice(defaultOriginalPrice);
				setProductId(defaultId);
				setProdId(defaultProdId);
			} else {
				message.error(res.data.message);
			}
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		getProduct();
	}, []);

	// GENERATING ORDERID
	const generateOrderId = () => {
		const numbers = "01234567"; // 8 numbers
		const randomNumbers = Array.from({ length: 7 }, () =>
			numbers.charAt(Math.floor(Math.random() * numbers.length))
		);
		const now = new Date();
		const day = String(now.getDate()).padStart(2, "0");
		const month = String(now.getMonth() + 1).padStart(2, "0"); // getMonth() is 0-indexed
		const year = String(now.getFullYear()).slice(2); // last two digits of the year
		const seconds = String(now.getSeconds()).padStart(2, "0");
		const orderId = `${year}${month}${day}${seconds}${randomNumbers.join("")}`;
		setOrderId(orderId);
	};

	useEffect(() => {
		generateOrderId();
	}, []);

	// PLAYER VALIDATIION
	async function handleCheckPlayer() {
		try {
			const payload = {
				game: product?.ogcode || 'MOBILE_LEGENDS_PRO',
				playerId: userId,
				server: zoneId,
			};
			const res = await apiClient.post("/games/validate-user", payload);
			if (res.data?.valid || res.data?.authenticated || (res.data?.response && res.data?.data?.status === 200)) {
				setPlayerCheck(res.data?.name || res.data?.data?.nickname || "");
			} else {
				message.error(res.data?.msg || "Validation failed");
			}
		} catch (error) {
			console.log(error);
		}
	}
	// CHECKING ORDER PLACEMENT
	function checkPlaceOrder(e, mode) {
		if (product.fields === "2") {
			if (userId === "") {
				return message.error(`Enter ${product?.tagOne}`);
			}
			if (zoneId === "") {
				return message.error(`Enter ${product?.tagTwo}`);
			}
		}
		if (product.fields === "1") {
			if (userId === "") {
				return message.error(`Enter ${product?.tagOne}`);
			}
		}
		if (product?.playerCheckBtn === "yes") {
			if (!playerCheck) {
				return message.error(`Validate your player first`);
			}
		}

		if (mode === "UPI") {
			handleUpiOrder(e);
		} else {
			handleWalletOrder(e);
		}
	}

	// New: CoinsUp Orders
	const handleUpiOrder = async (e) => {
		e.preventDefault();
		try {
			setLoading(true);
			const payload = {
				diamondPackId: prodId,
				playerId: userId.trim(),
				server: zoneId.trim(),
				amount: selectedPrice,
				quantity: 1,
				redirectUrl: `${window.location.origin}/order-status`,
				marketingConsent,
			};
			const res = await apiClient.post("/order/diamond-pack-upi", payload);
			if (res.data?.success && res.data?.transaction?.paymentUrl) {
				window.location.href = res.data.transaction.paymentUrl;
			} else {
				// Handle UPI payment failure - show gateway issue message
				message.error("Gateway issue. Please contact customer support.");
				alert('test')
				setLoading(false);
			}
		} catch (error) {
			console.log(error);
			// Handle UPI payment failure - show gateway issue message
			message.error("Gateway issue. Please contact customer support.");
			setLoading(false);
		}
	};

	const handleWalletOrder = async (e) => {
		if (parseInt(user?.walletBalance || 0) < parseInt(finalAmount)) {
			return message.error("Balance is less for this order");
		}
		e.preventDefault();
		try {
			setLoading(true);
			const payload = {
				diamondPackId: prodId,
				playerId: userId.trim(),
				server: zoneId.trim(),
				quantity: 1,
				marketingConsent,
			};
			const res = await apiClient.post("/order/diamond-pack", payload);
			if (res.data?.success) {
				message.success("Order placed successfully");
				setOrderSuccess(true);
				setLoading(false);
				console.log(res.data.orderId);
				
				navigate(`/order-status?orderId=${res.data.orderId}`);
			} else {
				// Handle wallet payment failure - show specific error message
				if (res.data?.error === "Insufficient wallet balance") {
					message.error(`Insufficient wallet balance. Required: ${res.data?.required}, Available: ${res.data?.available}`);
				} else {
					message.error(res.data?.message || "Order failed");
				}
				setLoading(false);
			}
		} catch (error) {
			console.log(error);
			// Handle wallet payment failure - show error message directly
			if (error.response?.data?.error === "Insufficient wallet balance") {
				message.error(`Insufficient wallet balance. Required: ${error.response.data?.required}, Available: ${error.response.data?.available}`);
			} else {
				message.error(error.response?.data?.message || "Order failed");
			}
			setLoading(false);
		}
	};

	const onClose = () => {
		dispatch(setActiveButton("home"));
		navigate("/");
		localStorage.setItem("activeButton", "home");
	};

	function closeBlackScreen(e) {
		e.stopPropagation();
		setMobilePopup(false);
	}

	// useEffect(() => {
	//   if (!!user?.email || !!user?.fname) {
	//     if (isMobile) {
	//       dispatch(setShowAccountModal(true));
	//     } else {
	//       navigate("/my-account");
	//     }
	//   }
	// }, [!!user?.email || !!user?.fname]);

	useEffect(() => {
		if (!user) {
			navigate("/login");
		}
		if (
			user?.fname === null ||
			user?.email === null ||
			user?.email === "" ||
			user?.fname === ""
		) {
			if (isMobile) {
				dispatch(setShowAccountModal(true));
			} else {
				navigate("/my-account");
			}
		}
	}, [user?.fname === ""]);

	return (
		<Layout>
			{loading ? (
				<Loader />
			) : (
				<>
					{/* DESKTOP */}
					{/* DESKTOP */}
					{/* DESKTOP */}
					<div className="product-info-container d-none d-lg-flex">
						<div className="pic">
							<div className="product-info-img bg-fields">
								<div className="game-name">
									<img src={`${(product?.image||"").startsWith("http")?"":website.link+"/"}${product?.image}`} alt="" />
								</div>
								<hr className="text-dark d-none d-lg-block" />
								<p className="m-0">
									<h4>{product?.name}</h4>
								</p>
								<p>
									<small>{product?.desc}</small>
								</p>
							</div>
						</div>

						<div className="product-info-content mb-2">
							{/* ====================== FIELDS ===============  */}
							{/* ====================== FIELDS ===============  */}
							<div className="bg-fields">
								<h5>Enter IDs</h5>
								{product?.fields === "1" ? (
									<div className="d-flex align-items-center">
										<input
											className="player-tag"
											type="text"
											name="userId"
											placeholder={product?.tagOne}
											onChange={(e) => setUserId(e.target.value)}
											value={userId}
										/>
									</div>
								) : product?.fields === "2" ? (
									<>
										<div className="d-flex align-items-center">
											<input
												className="player-tag"
												type="text"
												name="userId"
												placeholder={product?.tagOne}
												onChange={(e) => setUserId(e.target.value)}
												value={userId}
											/>
										</div>
										<input
											className="player-tag"
											type="text"
											name="zoneId"
											placeholder={product?.tagTwo}
											onChange={(e) => setZoneId(e.target.value)}
											value={zoneId}
										/>
									</>
								) : (
									product?.fields === "3" && (
										<>
											<div className="d-flex align-items-center">
												<input
													className="player-tag"
													type="text"
													name="userId"
													placeholder={`${product?.tagOne}`}
													onChange={(e) => setUserId(e.target.value)}
													value={userId}
												/>
											</div>
											<select
												name="zoneId"
												className="form-select player-tag"
												onChange={(e) => setZoneId(e.target.value)}
											>
												<option value="">Select Server</option>
												{product?.tagTwo?.split("+")?.map((item, index) => {
													return <option value={item}>{item}</option>;
												})}
											</select>
											{loading && (
												<>
													<div
														className="spinner-border spinner-border-sm me-2 mt-2"
														role="status"
													>
														<span className="visually-hidden"></span>
													</div>
													Checking Username
												</>
											)}
											<div>
												<span className="text-success">
													{playerCheck && "Username: " + playerCheck}
												</span>
											</div>
										</>
									)
								)}
								{product?.playerCheckBtn === "yes" && (
									<button className="buy-now" onClick={handleCheckPlayer}>
										Check Username
										{loading && (
											<div
												className="spinner-grow spinner-grow-sm"
												role="status"
											>
												<span className="visually-hidden">Loading...</span>
											</div>
										)}
									</button>
								)}
								{playerCheck !== null && (
									<p className="playername text-success">
										{playerCheck && "Username: " + playerCheck}
									</p>
								)}
							</div>
							{/* ====================== PACKAGE ===============  */}
							{/* ====================== PACKAGE ===============  */}
							<div className="bg-fields">
								<h5>Select Package</h5>
								<div className="p-amount">
									{product?.cost?.map((item, index) => {
										return (
											<div
												onClick={() => {
													setProdId(item?.prodId);
													setAmount(item?.amount);
													setPriceAndId(item?.amount, item?.prodId);
												}}
												key={index}
												className={`amount ${prodId === item?.prodId && "active"
													} ${item?.status === "no" && "disable"}`}
											>
												{item?.status === "no" && (
													<div className="outofstock">
														<span>Out of stock</span>
													</div>
												)}
												<div className="pack">
													<div className="d-flex align-items-center">
														{prodId === item?.prodId && <CheckCircleIcon />}
														{prodId !== item?.prodId && (
															<CheckCircleOutlineIcon />
														)}
														<img src={item?.pimg} alt="" />
														<div className="packdata">
															<span>{item.amount}</span>
															<span>{item.packData}</span>
														</div>
													</div>
													<div>
														<div className="price">
															₹
															{user?.reseller === "yes"
																? item?.resPrice
																: item?.price}
														</div>
														<div className="price fakeprice">
															<small>₹{item?.fakePrice}</small>
														</div>
													</div>
												</div>
											</div>
										);
									})}
								</div>
							</div>

							{/* ====================== COUPON ===============  */}
							{/* ====================== COUPON ===============  */}
							{/* <div className="bg-fields">
              {couponApplied ? (
                <>
                  <h5>Discount Applied</h5>
                  <div className="coupon-tag">
                    <p className="m-0">
                      {couponName} <CheckCircleOutlineIcon className="icon" />
                    </p>
                    <button className="remove-coupon" onClick={removeDiscount}>
                      Remove
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <h5>Apply Coupon</h5>
                  <div className="coupon-box">
                    <input
                      className="player-tag m-0 coupon-input"
                      type="text"
                      name="coupon"
                      placeholder="Enter Coupon"
                      onChange={(e) => setCoupon(e.target.value)}
                      value={coupon}
                    />
                    <button onClick={applyCoupon}>Apply</button>
                  </div>
                </>
              )}
              {error && coupon === "" && (
                <span className="text-danger">Enter valid coupon</span>
              )}
            </div> */}
							{/* ====================== PAYMENT METHOD ===============  */}
							{/* ====================== PAYMENT METHOD ===============  */}
							<div className="bg-fields">
								<h5>Choose the payment method</h5>
								<div className="payment-container">
									<div
										onClick={() => {
											setMode("WALLET");
											setPayment("WALLET");
										}}
										className={`payment wallet ${mode === "WALLET" && "active"
											}`}
									>
										{walletDiscount?.status && (
											<p className="m-0 text-end discount">
												{walletDiscount.discount}% OFF
											</p>
										)}
										<div className="d-flex align-items-center gap-1">
											<TollIcon className="icon" />
											<span>CS Coins</span>
										</div>
										{walletDiscount?.status ? (
											<span>
												₹
												{selectedPrice -
													(selectedPrice * walletDiscount.discount) / 100}
											</span>
										) : (
											<span>₹{selectedPrice}</span>
										)}
									</div>
									<div
										onClick={() => {
											setMode("UPI");
											setPayment("UPI");
										}}
										className={`payment upi ${payment === "UPI" && "active"}`}
									>
										<div>
											<img src={IMAGES.upi} alt="" />
										</div>
										<div>₹{selectedPrice}</div>
									</div>
									<div className="barcode-image">
										{mode === "UPI" && paymentMode === "barcode" && (
											<>
												<img src={img} alt="" />
												<div className="utrinput">
													<label className="text-white">Transaction Id</label>
													<input
														placeholder="Enter transaction Id"
														className="form-control"
														onChange={(e) => setUtr(e.target.value)}
														value={utr}
														type="text"
													/>
												</div>
												<button className="buy-now" onClick={checkPlaceOrder}>
													Submit
												</button>
												<p>{desc}</p>
											</>
										)}
									</div>
								</div>
							</div>

							{/* ====================== BUY NOW BUTTON ===============  */}
							{/* ====================== BUY NOW BUTTON ===============  */}
							{(paymentMode !== "barcode" || mode === "WALLET") && (
								<div className="bg-fields">
									<div className="total-value">
										<h5>Buy Now</h5>
										<div className="text-end">
											<p className="m-0">
												<b>
													₹
													{mode === "WALLET" && walletDiscount.status
														? selectedPrice -
														(selectedPrice * walletDiscount.discount || 0) /
														100
														: finalAmount}
												</b>
											</p>
											<span>
												<small>
													Amount {amount} |{" "}
													<span>
														Using -{" "}
														{paymentOptions !== "" ? paymentOptions : mode}
													</span>
												</small>
											</span>
										</div>
									</div>
									{user && !alreadyOptedIn && (
										<MarketingConsentCheckbox
											id="marketingConsentDesktop"
											className="mb-3"
											checked={marketingConsent}
											onChange={setMarketingConsent}
										/>
									)}
									<div className="buy-btn-container">
										{user?.block === "yes" || product?.stock === "no" ? (
											<button className="buy-now" style={{ opacity: "0.7" }}>
												Out of Stock
											</button>
										) : !user ? (
											<button
												onClick={() => navigate("/login")}
												className="buy-now"
											>
												Please Login First
											</button>
										) : (
											<button
												onClick={(e) => checkPlaceOrder(e, mode)}
												className="buy-now"
											>
												BUY NOW
											</button>
										)}
									</div>
								</div>
							)}
						</div>
					</div>

					{/* =================================================================================== */}
					{/* =================================================================================== */}
					{/* =================================================================================== */}
					{/* =================================================================================== */}
					{/* MOBILE */}
					{/* MOBILE */}
					{/* MOBILE */}
					<div className={`account-modal-container d-lg-none d-md-none `}>
						<HeroSvg />
						<div className="account-modal-container-content">
							<div className="top-left-content">
								<div className="box-1 center" onClick={onClose}>
									<ChevronLeftSvg />
								</div>
								<h2 className="mb-0">{product?.name}</h2>
							</div>
							<div
								className="top-right-content box-2 center"
								onClick={() => setSideMenu(!sideMenu)}
							>
								<ListSvg />
							</div>
						</div>
						<div className="mobile-product-info-container">
							{/* PRODUCT NAME  */}
							<div className="product-name-image">
								<div className="image">
									<img src={`${(product?.image||"").startsWith("http")?"":website.link+"/"}${product?.image}`} alt="" />
								</div>
								<div className="name">
									<h6>{product?.name}</h6>
									<span>
									
									</span>
								</div>
							</div>
							{/* SOCIAL LINKS */}
							<div className="social-media-links">
								<FacebookOutlinedIcon
									onClick={() =>
										window.open(
											"https://www.facebook.com/profile.php?id=61571086715290"
										)
									}
									className="icon facebook"
								/>
								<InstagramIcon
									onClick={() =>
										window.open("https://www.instagram.com/coinssups/")
									}
									className="icon instagram"
								/>
								<YouTubeIcon
									onClick={() =>
										window.open("https://www.youtube.com/@coinsup-c3u")
									}
									className="icon youtube"
								/>
								<TelegramIcon
									onClick={() => window.open("https://t.me/coinssups")}
									className="icon telegram"
								/>
							</div>
							{/* USER INPUTS */}
							<div className="mobile-user-inputs">
								<div className="input-heading">
									<span>Enter your information</span>
								</div>
								<hr className="text-dark m-0" />
								{product?.fields === "1" ? (
									<div className="user-field first-field">
										{product?.playerCheckBtn === "yes" && (
											<button
												onClick={handleCheckPlayer}
												disabled={userId === ""}
												style={userId === "" ? { opacity: "0.7" } : {}}
											>
												Validate
											</button>
										)}
										<UserIdSvg />
										<input
											autoComplete="off"
											className="active"
											type="text"
											name="userId"
											placeholder={product?.tagOne}
											onChange={(e) => setUserId(e.target.value)}
											value={userId}
										/>
										<hr className="text-dark" />
									</div>
								) : product?.fields === "2" ? (
									<>
										<div className="user-field first-field">
											{product?.playerCheckBtn === "yes" && (
												<button
													onClick={handleCheckPlayer}
													disabled={zoneId === ""}
													style={zoneId === "" ? { opacity: "0.7" } : {}}
												>
													Validate
												</button>
											)}
											<UserIdSvg />
											<input
												autoComplete="off"
												className="active"
												type="number"
												name="userId"
												placeholder={product?.tagOne}
												onChange={(e) => setUserId(e.target.value)}
												value={userId}
											/>
										</div>
										{playerCheck && (
											<span className="usernamecheck">{playerCheck}</span>
										)}
										<div className="user-field">
											<ZoneIdSvg />
											<input
												autoComplete="off"
												name="zoneId"
												type="text"
												placeholder={product?.tagTwo}
												onChange={(e) => setZoneId(e.target.value)}
												value={zoneId}
											/>
										</div>
									</>
								) : (
									product?.fields === "3" && (
										<>
											<div className="user-field first-field">
												{product?.playerCheckBtn === "yes" && (
													<button
														style={zoneId === "" ? { opacity: "0.7" } : {}}
														disabled={zoneId === ""}
														onClick={handleCheckPlayer}
													>
														Validate
													</button>
												)}
												<UserIdSvg />
												<input
													autoComplete="off"
													className="active"
													type="number"
													placeholder={product?.tagOne}
													onChange={(e) => setUserId(e.target.value)}
													value={userId}
												/>
											</div>
											<div className="user-field">
												<ZoneIdSvg />
												<select
													name="zoneId"
													className="form-select select-tag"
													onChange={(e) => setZoneId(e.target.value)}
													value={zoneId}
												>
													<option value="">Select Server</option>
													{product?.tagTwo?.split("+")?.map((item, index) => {
														return <option value={item}>{item}</option>;
													})}
												</select>
											</div>
										</>
									)
								)}
							</div>
							{/* PACKAGE */}
							<div className="mobile-package-container">
								{product?.cost?.map((item, index) => {
									return (
										<div
											onClick={() => {
												setProdId(item?.prodId);
												setAmount(item.amount);
												setPriceAndId(item.amount, item?.prodId);
											}}
											key={index}
											className={`amount ${prodId === item?.prodId && "active"
												} ${item?.status === "no" && "disable"}`}
										>
											{item?.status === "no" && (
												<div className="outofstock">
													<span>Out of stock</span>
												</div>
											)}
											<div className="pack">
												<div className="d-flex">
													<img src={item?.pimg} alt="" />
													<div className="d-flex flex-column justify-content-center">
														<p>{item?.packData}</p>
														{/* {item?.packData && <p>{item?.packData}</p>} */}
													</div>
												</div>
												<div className="d-flex">
													{item?.fakePrice && (
														<div className="price fakeprice">
															<>₹{item?.fakePrice}</>
														</div>
													)}
													<div className="price">
														₹
														{user?.reseller === "yes"
															? item?.resPrice
															: item?.price}
													</div>
												</div>
											</div>
										</div>
									);
								})}
							</div>

							{/* BUY NOW */}
							{/* BUY NOW */}
							{/* BUY NOW */}
							{!user ? (
								<div
									onClick={() => navigate("/login")}
									className="mobile-buy-now-button"
								>
									Please Login first
								</div>
							) : product?.fields === "1" && userId !== "" ? (
								<div
									className="mobile-buy-now-button"
									onClick={() => setMobilePopup(true)}
								>
									Continue with ₹{parseFloat(finalAmount).toFixed(2)}
								</div>
							) : (product?.fields === "2" || product?.fields === "3") &&
								userId !== "" &&
								zoneId !== "" &&
								playerCheck ? (
								<div
									className="mobile-buy-now-button"
									onClick={() => setMobilePopup(true)}
								>
									Continue with ₹{parseFloat(finalAmount).toFixed(2)}
								</div>
							) : (
								(product?.fields === "2" || product?.fields === "3") &&
								userId !== "" &&
								zoneId !== "" &&
								product?.playerCheckBtn === "no" && (
									<div
										className="mobile-buy-now-button"
										onClick={() => setMobilePopup(true)}
									>
										Continue with ₹{parseFloat(finalAmount).toFixed(2)}
									</div>
								)
							)}

							{/* POPUP  */}
							{/* POPUP  */}
							{/* POPUP  */}
							{mobilePopup && (
								<div className="confirmation-popup">
									<div className="questionicon">
										<ClearIcon
											className="clearicon"
											onClick={() => setMobilePopup(false)}
										/>
										<QuestionMarkIcon className="icon" />
									</div>
									<h4>Are you Sure!</h4>
									<span>Do you want continue with this order?</span>
									<div className="order-game-details">
										<div className="product-name-image">
											<div className="image">
												<img src={`${product?.image}`} alt="" />
											</div>
											<div className="name">
												<h6>{product?.name}</h6>
												<span>
													{playerCheck ? (
														<div className="d-flex align-items-center">
															<span>{playerCheck}</span>
															<VerifiedIcon className="icon" />
														</div>
													) : (
														"N.A"
													)}
												</span>
											</div>
										</div>
										<div className="order-user-details">
											<div className="items">
												<span>Item</span>
												<span>{amount}</span>
											</div>
											<div className="items">
												<span>{product?.tagOne}</span>
												<span>{userId}</span>
											</div>
											<div className="items">
												<span>Amount</span>
												<span>₹{finalAmount}</span>
											</div>

											<div className="items">
												<span>CS Coins</span>
												<span>₹{parseFloat(user?.walletBalance || 0).toFixed(2)}</span>
											</div>
											{product?.cost?.find(item => item.prodId === prodId)?.cashback && (
												<div className="discount-tab">
													<span style={{color: "green", fontWeight: "bold"}}>
													Get Assured Cashback on Every Recharge
													</span>{" "}
												</div>
											)}
										</div>

										{!alreadyOptedIn && (
											<MarketingConsentCheckbox
												id="marketingConsentMobile"
												className="mt-3"
												checked={marketingConsent}
												onChange={setMarketingConsent}
											/>
										)}
										<div className="mobile-pay-buttons">
											<button onClick={(e) => checkPlaceOrder(e, "WALLET")}>
												<div>Pay Via CS Coins -</div>
												{/* <div style={{color: "green"}}> {product?.cost?.find(item => item.prodId === prodId)?.cashback || 0} coins cashback</div> */}
											</button>
											<button onClick={(e) => checkPlaceOrder(e, "UPI")}>
												Pay Via UPI
											</button>
										</div>
									</div>
								</div>
							)}

							{mobilePopup && <div className="blackscreen"></div>}
						</div>
					</div>
				</>
			)}
			<SideMenu sideMenu={sideMenu} setSideMenu={setSideMenu} />
			<AccountModal show={showAccountModal} user={user} />{" "}
		</Layout>
	);
};

export default ProductInfo;
